import script from "./MasterDataFuelPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterDataFuelPage.vue?vue&type=script&setup=true&lang=js"

import "./MasterDataFuelPage.vue?vue&type=style&index=0&id=d8e21d1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8e21d1a"]])

export default __exports__